import './App.css';
import React, { useState } from "react";
import Homepage from './Homepage';
import Week1 from './projects/Week1';
import Week2 from './projects/Week2';
import Navbar, {Navmenu} from './Navbar';
import Week3 from './projects/Week3';
import SlideMenu from './SlideMenu';
import Final from './projects/Final';
import Week4 from './projects/Week4';
import Week5 from './projects/Week5';
import Week6 from './projects/Week6';
import Week7 from './projects/Week7';
import Week8 from './projects/Week8';
import Week9 from './projects/Week9';
import Week10 from './projects/Week10';
import Week11 from './projects/Week11';
import Week12 from './projects/Week12';
import Week13 from './projects/Week13';
import Week14 from './projects/Week14';

function App() {
  const [page,setPage] = useState('home');
  const changePage = (page) => {
    window.scrollTo(0,0);
    setPage(page);
  }

  const [menu, setMenu] = useState(false);
  const handleMenu = () => {
    if(menu) setMenu(false);
  }
  return (<>
    <SlideMenu menu={menu} navmenu={ Navmenu} setMenu={setMenu} setPage={setPage}/>
      <Navbar prefix="/" menu={menu} setMenu={setMenu} setPage={changePage}/>
      <div className="App-page" onClick={() => handleMenu()}>
        {page === 'home'? <Homepage changePage={changePage}/>
        :page === 'week14'?<Week14/>
        :page === 'week13'?<Week13/>
        :page === 'week12'?<Week12 changePage={changePage}/>
        :page === 'week11'?<Week11 />
        :page === 'week10'?<Week10 />
        :page === 'week9'?<Week9 />
        :page === 'week8'?<Week8 />
        :page === 'week7'?<Week7 />
        :page === 'week6'?<Week6 changePage={changePage}/>
        :page === 'week5'?<Week5 />
        :page === 'week4'?<Week4 />
        :page === 'week3'?<Week3 />
        :page === 'week2'?<Week2 />
        :page === 'week1'?<Week1 />
        :page === 'final'?<Final changePage={changePage}/>
        :<Homepage changePage={changePage}/>}
      </div>
      </>
  );
}

export default App;
